import React from 'react';
import sanitizePhone from '../utils/sanitizePhone';

const AdmissionContactTable = ({ contacts = [], setContacts }) => {
  if (typeof setContacts !== 'function') {
    console.error('setContacts is not a function!');
    return <div>Error: Invalid props provided to CustomerContactTable</div>;
  }

  // continue as normal...
  const handleChange = (index, field, value) => {
    const updated = [...contacts];
    if (field === 'contactNo' || field === 'anotherContactNo') {
      value = sanitizePhone(value);
    }

    updated[index][field] = value;
    setContacts(updated);
  };


  const handleDelete = (index, event) => {
    event.preventDefault();
    const updated = contacts.filter((_, i) => i !== index);
    setContacts(updated);
  };

  const handleAddRow = (event) => {
    event.preventDefault();
    setContacts([
      ...contacts,
      {
        firstName: '',
        lastName: '',
        email: '',
        contactNo: '',
        anotherContactNo: '',
      },
    ]);
  };

  return (
    <div className="customer-table customer-contact-table">
      <table>
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Contact No</th>
            <th>Another Contact No</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((customer, index) => (
            <tr key={index}>
              <td>
                <input
                  type="text"
                  value={customer.firstName}
                  onChange={(e) => handleChange(index, 'firstName', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={customer.lastName}
                  onChange={(e) => handleChange(index, 'lastName', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="email"
                  value={customer.email}
                  onChange={(e) => handleChange(index, 'email', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={customer.contactNo}
                  // maxLength={10}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) e.preventDefault();
                  }}

                  onChange={(e) => handleChange(index, 'contactNo', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={customer.anotherContactNo}
                  // maxLength={10}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) e.preventDefault();
                  }}

                  onChange={(e) => handleChange(index, 'anotherContactNo', e.target.value)}
                />
              </td>
              <td>
                <button onClick={(event) => handleDelete(index, event)}>
                  <i className="fa-solid fa-trash delete-oms"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="oms-add-btn customer-page-btn" onClick={handleAddRow}>
        Add Row
      </button>
    </div>
  );
};

export default AdmissionContactTable;
